import { createStore } from "redux-dynamic-modules";
import { getSagaExtension } from "redux-dynamic-modules-saga";
import { mapValues } from "lodash";

import reducers from "./rootReducer";
import rootSaga from "./rootSaga";
import authConstants from "./auth/CONSTANTS";
import { initState as authInitState } from "./auth/reducer";
import { initState as commonInitState } from "./common/reducer";
import persistStoreFields from "./persistStoreFields";
import CONSTANTS from "./auth/CONSTANTS";
const { LS_LOGGED_IN, LS_SIDEBAR_OPEN, LS_USER_MUST_CHANGE_PASSWORD } = CONSTANTS;

const addResetToReducer = originalReducer => (state, action) => {
  const resetAllReducers = action.type === authConstants.RESET_ALL;
  return originalReducer(resetAllReducers ? undefined : state, action);
};

const rootReducer = mapValues(reducers, addResetToReducer);

const rootModule = {
  id: "root",
  reducerMap: rootReducer,
  sagas: [rootSaga]
};

// returns null if item does not exist
const getLocalStorageBooleanItem = key => {
  const value = localStorage.getItem(key);
  if (!value) return;
  return value === String(true);
};

const loggedIn = getLocalStorageBooleanItem(LS_LOGGED_IN);
const sidebarOpen = getLocalStorageBooleanItem(LS_SIDEBAR_OPEN);
const userMustChangePassword = getLocalStorageBooleanItem(LS_USER_MUST_CHANGE_PASSWORD);

const initialState = {
  auth: {
    ...authInitState,
    loggedIn: loggedIn ?? authInitState.loggedIn,
    userMustChangePassword: userMustChangePassword ?? authInitState.userMustChangePassword
  },
  common: {
    ...commonInitState,
    sidebarOpen: sidebarOpen ?? commonInitState.sidebarOpen,
  }
};

const moduleStoreSettings = {
  initialState,
  extensions: [
    getSagaExtension({})
  ]
};

export const store = createStore(moduleStoreSettings, rootModule);

const convertStorageBoolean = strVal => strVal === String(true);

persistStoreFields(store, [
  {
    name: LS_SIDEBAR_OPEN,
    select: state => state.common.sidebarOpen,
    convert: convertStorageBoolean
  },
  {
    name: LS_LOGGED_IN,
    select: state => state.auth.loggedIn,
    convert: convertStorageBoolean
  },
  {
    name: LS_USER_MUST_CHANGE_PASSWORD,
    select: state => state.auth.userMustChangePassword,
    convert: convertStorageBoolean
  },
]);
